export const BATCH_ACTION_TYPES = {
    DUPLICATE: 'Duplicate',
    MOVE_TO: 'Move To',
    COPY_TO: 'Copy To',
    DOWNLOAD: 'Download',
    PUBLISH: 'Publish',
    DELETE: 'Delete',
    TAG: 'Tag',
}; 


// WEBPACK FOOTER //
// ./src/enums/AssetBatchActionTypes.js